export default __webpack_public_path__ + "static/media/umbra_mala.470e310e.png";